import { OPENING_BLOCK_STEP } from "./openingBlockConstants";

export const PROPOSAL_CONFIRM_ANCHOR_STEP = "exibe_dados_cadastrais";

export const PROPOSAL_CONFIRM_PRELUDE_STEPS = new Set([
  "revisao_dados_pessoais",
  "confirmacao_dados_cadastrais",
  "mensagem_resolucao_285",
  "termos_regulamento",
]);

const PROPOSAL_CONFIRM_BLOCK_STEPS = new Set([
  ...PROPOSAL_CONFIRM_PRELUDE_STEPS,
  PROPOSAL_CONFIRM_ANCHOR_STEP,
]);

const META_STEPS = ["verifica_retomada", "retomar_conversa"];

const hasInteractiveOptions = (step) => {
  const rawOptions =
    typeof step.options === "function" ? step.options() : step.options;

  return (
    (rawOptions?.length ?? 0) > 0 ||
    (step.stepButtons?.length ?? 0) > 0 ||
    (step.buttons?.length ?? 0) > 0
  );
};

export const isAutoAdvanceStep = (step) => {
  if (!step?.name || META_STEPS.includes(step.name)) return false;
  if (step.name === OPENING_BLOCK_STEP) return false;
  if (step.inputType || step.useCarousel || step.useCarouselPlan) return false;
  if (hasInteractiveOptions(step)) return false;

  return Boolean(step.action || step.nextStep !== undefined);
};

export const buildPreludeBlockItems = (pendingMessageBlock = []) =>
  pendingMessageBlock
    .filter((entry) => entry?.message)
    .map((entry) => ({
      type: "text",
      message: String(entry.message),
      ...(entry.step ? { step: entry.step } : {}),
    }));

export const isProposalConfirmBlockStep = (stepName) =>
  PROPOSAL_CONFIRM_BLOCK_STEPS.has(stepName);

export const historicoHasUnifiedProposalBlock = (historico = []) =>
  historico.some((entry) => {
    if (entry.step !== PROPOSAL_CONFIRM_ANCHOR_STEP || entry.sender !== "bot") {
      return false;
    }

    const textCount = (entry.items ?? []).filter(
      (item) => item.type === "text" && item.message
    ).length;

    return textCount >= 4;
  });
